import _regeneratorRuntime from "@babel/runtime/regenerator";
function asyncGeneratorStep(gen, resolve, reject, _next, _throw, key, arg) { try { var info = gen[key](arg); var value = info.value; } catch (error) { reject(error); return; } if (info.done) { resolve(value); } else { Promise.resolve(value).then(_next, _throw); } }
function _asyncToGenerator(fn) { return function () { var self = this, args = arguments; return new Promise(function (resolve, reject) { var gen = fn.apply(self, args); function _next(value) { asyncGeneratorStep(gen, resolve, reject, _next, _throw, "next", value); } function _throw(err) { asyncGeneratorStep(gen, resolve, reject, _next, _throw, "throw", err); } _next(undefined); }); }; }
import { Head } from '@inertiajs/inertia-vue3';
import Icon from '@/Shared/Icon';
import pickBy from 'lodash/pickBy';
import Layout from '@/Shared/Layout';
import throttle from 'lodash/throttle';
import mapValues from 'lodash/mapValues';
import Pagination from '@/Shared/Pagination';
import SearchFilter from '@/Shared/SearchFilter';
import { Link } from '@inertiajs/inertia-vue3';
import { ElMessage } from 'element-plus';
export default {
  components: {
    Head: Head,
    Icon: Icon,
    Pagination: Pagination,
    SearchFilter: SearchFilter,
    Link: Link
  },
  layout: Layout,
  props: {
    solutions: Object,
    industries: Object,
    tenants: Object
  },
  data: function data() {
    return {
      form: {
        solution: null,
        tenant_id: null,
        industry: null,
        revenue: null,
        contact: null,
        email_count: null,
        lead_count: 1,
        max_lead_count: null,
        currentPage: 1,
        order_by: 'lead_percent',
        order: 'desc'
      },
      solutionData: [],
      countData: {
        totalRows: 0,
        total: 0,
        lead: 0,
        no_lead: 0,
        total_contacts: 0,
        lead_contacts: 0,
        no_lead_contacts: 0
      },
      resetPaginate: false
    };
  },
  methods: {
    resetSearch: function resetSearch(resetSolution) {
      if (resetSolution == 'SOLUTION' || resetSolution == 'ALL') {
        this.form.solution = null;
      }
      if (resetSolution == 'TENANT' || resetSolution == 'ALL') {
        this.form.tenant_id = null;
      }
      this.form.industry = null;
      this.form.revenue = null;
      this.form.contact = null;
      this.form.email_count = null;
      this.form.lead_count = 1;
      this.form.max_lead_count = null;
      this.form.currentPage = 1;
      this.form.order_by = 'lead_percent';
      this.form.order = 'desc';
      this.getParameterData();
    },
    getParameterData: function getParameterData() {
      var _this = this;
      return _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee() {
        var res;
        return _regeneratorRuntime.wrap(function _callee$(_context) {
          while (1) {
            switch (_context.prev = _context.next) {
              case 0:
                if (_this.resetPaginate) {
                  _this.form.currentPage = 1;
                  _this.resetPaginate = false;
                }
                _this.$store.loading = true;
                _context.next = 4;
                return axios.post('/get_solution_data', _this.form);
              case 4:
                res = _context.sent;
                _this.solutionData = res.data.solutionData;
                _this.countData = res.data.countData;
                _this.$store.loading = false;
              case 8:
              case "end":
                return _context.stop();
            }
          }
        }, _callee);
      }))();
    },
    pageChange: function pageChange(e) {
      this.form.currentPage = e;
      this.getParameterData();
    },
    sortChange: function sortChange(e) {
      this.form.order_by = e.prop;
      this.form.order = e.order == 'ascending' ? 'asc' : 'desc';
      this.getParameterData();
    }
  }
};